import { toast } from 'sonner';

export const showSuccess = (message) => {
  toast.success(message, {
    duration: 3000,
  });
};

export const showError = (message) => {
  toast.error(message, {
    duration: 4000,
  });
};

export const showInfo = (message) => {
  toast.info(message, {
    duration: 3000,
  });
};

export const showWarning = (message) => {
  toast.warning(message, {
    duration: 3000,
  });
};

export const showApiMessage = (response, defaultSuccess = 'عملیات با موفقیت انجام شد', defaultError = 'خطا در انجام عملیات') => {
  // Check for error first
  if (response?.error || response?.success === false) {
    const errorMsg = response?.message || (typeof response?.error === 'string' ? response.error : null) || defaultError;
    showError(errorMsg);
  } else {
    // Treat as success if no error is explicitly present
    showSuccess(response?.message || defaultSuccess);
  }
};



